"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCpf = void 0;
const format_1 = require("../format");
function validateCpf(userDocument) {
    const docnumber = (0, format_1.formatStringToNumber)(userDocument);
    if ((0, format_1.isRepeatedDigitText)(docnumber)) {
        return false;
    }
    const verifyDigits = (digits) => {
        const dividerNumber = 11;
        const numbers = digits.split('').map((number) => parseInt(number, 10));
        const modulus = numbers.length + 1;
        const multiplied = numbers.map((number, index) => number * (modulus - index));
        const mod = multiplied.reduce((buffer, number) => buffer + number, 0) % dividerNumber;
        return mod < 2 ? 0 : dividerNumber - mod;
    };
    let digits = docnumber.substring(0, 9);
    digits += verifyDigits(digits);
    digits += verifyDigits(digits);
    return digits.substring(-2) === docnumber.substring(-2);
}
exports.validateCpf = validateCpf;
